import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import { PATHS } from 'src/constants/config';

import ProtectedLayout from 'src/layouts/ProtectedLayout';
import NotFound from 'src/components/NotFound';
import useQueueProcessor from 'src/hooks/useQueueProcessor';
import QueueProgressDrawer from 'src/components/QueueProgressDrawer';

import Login from 'src/pages/Auth/Login';
import EditProfile from 'src/pages/Auth/EditProfile';

import QueryProfile from 'src/pages/QueryPages/QueryProfile/QueryProfile';
import PitchInbox from 'src/pages/QueryPages/PitchInbox';
import Successful from 'src/pages/QueryPages/Successful';
import Repurpose from 'src/pages/QueryPages/Repurpose';
import Discarded from 'src/pages/QueryPages/Discarded';

import Experts from 'src/pages/Experts/Experts';
import Reports from 'src/pages/Reports/Reports';
import ReportProfile from 'src/pages/Reports/ReportProfile';
import WinsDashboard from '@/pages/WinsDashboard/WinsDashboard';
import WinsDashboardProfile from '@/pages/WinsDashboard/WinsDashboardProfile';
import ExpertAuth from 'src/pages/Auth/ExpertAuth';
import ManageOutlets from 'src/pages/ManageOutlets/ManageOutlets';
import ManageKeywords from 'src/pages/ManageKeywords/ManageKeywords';
import Tools from 'src/pages/Tools/Tools';
import Docs from 'src/pages/Docs/Docs';

const AppRoutes = () => {
  useQueueProcessor();

  return (
    <>
      <QueueProgressDrawer />
      <Router
        future={{
          v7_relativeSplatPath: true,
          v7_startTransition: true,
        }}
      >
        <Routes>
          {/* Auth */}
          <Route path={PATHS.AUTH.LOGIN.value} element={<Login />} />
          <Route path={PATHS.AUTH.EXPERT_AUTH.value} element={<ExpertAuth />} />

          {/* Profile */}
          <Route
            path={PATHS.PROFILE.EDIT.value}
            element={
              <ProtectedLayout>
                <EditProfile />
              </ProtectedLayout>
            }
          />

          {/* Query Profile */}
          <Route
            path={PATHS.QUERY_PROFILE.value}
            element={
              <ProtectedLayout>
                <QueryProfile />
              </ProtectedLayout>
            }
          />

          {/* Unified Pitch Inbox */}
          <Route
            path={PATHS.PITCH_INBOX.value}
            element={
              <ProtectedLayout>
                <PitchInbox />
              </ProtectedLayout>
            }
          />

          {/* Successful */}
          <Route
            path={PATHS.SUCCESSFUL.value}
            element={
              <ProtectedLayout>
                <Successful />
              </ProtectedLayout>
            }
          />

          {/* Other */}
          <Route
            path={PATHS.EXPERT.value}
            element={
              <ProtectedLayout>
                <Experts />
              </ProtectedLayout>
            }
          />

          {/* Manage Outlets */}
          <Route
            path={PATHS.MANAGE_OUTLETS.value}
            element={
              <ProtectedLayout>
                <ManageOutlets />
              </ProtectedLayout>
            }
          />

          {/* Manage Keywords */}
          <Route
            path={PATHS.MANAGE_KEYWORDS.value}
            element={
              <ProtectedLayout>
                <ManageKeywords />
              </ProtectedLayout>
            }
          />

          {/* Tools and Reports */}
          <Route
            path={PATHS.TOOLS.value}
            element={
              <ProtectedLayout>
                <Tools />
              </ProtectedLayout>
            }
          />

          {/* Repurpose */}
          <Route
            path={PATHS.REPURPOSE.value}
            element={
              <ProtectedLayout>
                <Repurpose />
              </ProtectedLayout>
            }
          />

          {/* Reports */}
          <Route
            path={PATHS.REPORTS.INDEX.value}
            element={
              <ProtectedLayout>
                <Reports />
              </ProtectedLayout>
            }
          />
          <Route
            path={PATHS.REPORTS.PROFILE.value}
            element={
              <ProtectedLayout showNavBar={false}>
                <ReportProfile />
              </ProtectedLayout>
            }
          />

          {/* Wins Dashboard */}
          <Route
            path={PATHS.WINS_DASHBOARD.INDEX.value}
            element={
              <ProtectedLayout>
                <WinsDashboard />
              </ProtectedLayout>
            }
          />

          <Route
            path={PATHS.WINS_DASHBOARD.PROFILE.value}
            element={
              <ProtectedLayout>
                <WinsDashboardProfile />
              </ProtectedLayout>
            }
          />

          {/* Docs */}
          <Route
            path={PATHS.DOCS.value}
            element={
              <ProtectedLayout>
                <Docs />
              </ProtectedLayout>
            }
          />

          {/* Discarded */}
          <Route
            path={PATHS.DISCARDED.value}
            element={
              <ProtectedLayout>
                <Discarded />
              </ProtectedLayout>
            }
          />

          {/* Utility */}
          <Route
            path={PATHS.HOME.value}
            element={
              <ProtectedLayout>
                <Navigate to={PATHS.PITCH_INBOX.value} />
              </ProtectedLayout>
            }
          />
          <Route
            path="*"
            element={
              <ProtectedLayout>
                <NotFound />
              </ProtectedLayout>
            }
          />
        </Routes>
      </Router>
    </>
  );
};

export default AppRoutes;
